import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Dropdown from 'flarum/common/components/Dropdown';
import app from 'flarum/forum/app';
import CloseTicketModal from '../Modals/CloseTicketModal';
import extractText from 'flarum/common/utils/extractText';
import UpdateTicketStatusModal from '../Modals/UpdateTicketStatusModal';
import UpdateTicketSubjectModal from '../Modals/UpdateTicketSubjectModal';

export default class SupportTicketDropdown extends Component {
  view() {
    const discussion = this.attrs.ticket.discussion();
    const isAssigned =
      this.attrs.ticket.assignees && this.attrs.ticket.assignees().find((assignee) => assignee && assignee.user() == app.session.user);
    let buttons = [];

    if (!this.attrs.ticketView) {
      buttons.push(
        Button.component(
          {
            className: 'Button',
            onclick: () => m.route.set(app.route('ticketsView', { id: discussion.id() })),
            icon: 'far fa-eye',
          },
          app.translator.trans('v17development-flarum-support.forum.tickets.tools.view_ticket')
        )
      );

      // Assign yourself
      if (!isAssigned) {
        buttons.push(
          Button.component(
            {
              className: 'Button',
              onclick: () => {
                const supportTicketAssignee = app.store.createRecord('supportTicketAssignees');

                supportTicketAssignee
                  .save({
                    relationships: {
                      ticket: this.attrs.ticket,
                      user: app.session.user,
                    },
                  })
                  .then(() => m.redraw());
              },
              icon: 'fas fa-user-plus',
            },
            app.translator.trans('v17development-flarum-support.forum.tickets.tools.assign_me')
          )
        );
      } else {
        buttons.push(
          Button.component(
            {
              className: 'Button',
              onclick: () => isAssigned.delete().then(() => m.redraw()),
              icon: 'fas fa-user-times',
            },
            app.translator.trans('v17development-flarum-support.forum.tickets.tools.remove_me')
          )
        );
      }
    }

    // Rename ticket
    if (discussion.canRename()) {
      buttons.push(
        Button.component(
          {
            className: 'Button',
            onclick: () =>
              app.modal.show(UpdateTicketSubjectModal, {
                ticket: discussion,
                redirect: false,
              }),
            icon: 'fas fa-pencil-alt',
          },
          app.translator.trans('v17development-flarum-support.forum.tickets.tools.update_subject')
        )
      );
    }

    buttons.push(<li className="Dropdown-separator" />);

    // Ticket status
    buttons.push(
      Button.component(
        {
          className: 'Button',
          onclick: () =>
            app.modal.show(UpdateTicketStatusModal, {
              ticket: this.attrs.ticket,
            }),
          icon: 'fas fa-wrench',
        },
        app.translator.trans('v17development-flarum-support.forum.tickets.tools.update_status')
      )
    );

    // Ticket
    buttons.push(
      Button.component(
        {
          className: 'Button',
          onclick: () => app.modal.show(CloseTicketModal, { ticket: this.attrs.ticket }),
          icon: 'fas fa-times',
        },
        app.translator.trans('v17development-flarum-support.forum.tickets.tools.close_ticket')
      )
    );

    // Can convert into discussion?
    if (this.attrs.ticket.canConvertIntoDiscussion()) {
      // Add separator
      buttons.push(<li className="Dropdown-separator" />);

      // Turn ticket into discussion
      buttons.push(
        Button.component(
          {
            className: 'Button',
            icon: 'fas fa-comment-slash',
            onclick: () => {
              if (!confirm(extractText(app.translator.trans('v17development-flarum-support.forum.tickets.convert_to_discussion.confirm'))))
                return false;

              this.attrs.ticket.delete().then(() => {
                if (
                  confirm(
                    extractText(
                      app.translator.trans('v17development-flarum-support.forum.tickets.convert_to_discussion.event', {
                        ticket_title: discussion.title(),
                      })
                    )
                  )
                ) {
                  // Redirect to discussion
                  m.route.set(app.route('discussion', { id: discussion.id() }));
                }
              });
            },
            // loading: convertingIntoTicket,
          },
          app.translator.trans('v17development-flarum-support.forum.tickets.convert_to_discussion.button')
        )
      );
    }

    return Dropdown.component(
      {
        icon: this.attrs.ticketView ? '' : 'fas fa-ellipsis-v',
        label: this.attrs.ticketView ? 'Ticket settings' : '',
        buttonClassName: `Button`,
        menuClassName: 'Dropdown-menu--right',
      },
      buttons
    );
  }
}
